import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueHiddenTitle: {
		id: 'backlog.flags.card-create-unmapped.issue-hidden-title',
		defaultMessage:
			'Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible',
		description: "Unmapped Issue's Status Title",
	},
	issueHiddenDescription: {
		id: 'backlog.flags.card-create-unmapped.issue-hidden-description',
		defaultMessage:
			'The issue is assigned to a status that’s not visible on the board and backlog.',
		description:
			'Text within a flag to indicate an issue has been created that are not visible because their status is unmapped',
	},
	multipleIssuesHiddenDescription: {
		id: 'backlog.flags.card-create-unmapped.multiple-issues-hidden-description',
		defaultMessage:
			'{numIssues} issues have been created, but one or more have a status that’s not visible on the board and backlog.',
		description:
			'Text within a flag to indicate that multiple issues have been created that are not visible because their status is unmapped',
	},
	assignStatuses: {
		id: 'backlog.flags.card-create-unmapped.assign-statuses',
		defaultMessage: 'Assign statuses',
		description: 'Link to column status mapping page',
	},
	issueHiddenTitleIssueTermRefresh: {
		id: 'backlog.flags.card-create-unmapped.issue-hidden-title-issue-term-refresh',
		defaultMessage:
			'Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible',
		description: "Unmapped Issue's Status Title",
	},
	issueHiddenDescriptionIssueTermRefresh: {
		id: 'backlog.flags.card-create-unmapped.issue-hidden-description-issue-term-refresh',
		defaultMessage:
			'The work item is assigned to a status that’s not visible on the board and backlog.',
		description:
			'Text within a flag to indicate an issue has been created that are not visible because their status is unmapped',
	},
	multipleIssuesHiddenDescriptionIssueTermRefresh: {
		id: 'backlog.flags.card-create-unmapped.multiple-issues-hidden-description-issue-term-refresh',
		defaultMessage:
			'{numIssues} work items have been created, but one or more have a status that’s not visible on the board and backlog.',
		description:
			'Text within a flag to indicate that multiple issues have been created that are not visible because their status is unmapped',
	},
});
